/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const VocalIcon = createIcon(
  '0 0 20 20',
  <path d="M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-2.5 1 1 7h3l1-7z" />,
);
